(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 222);
/******/ })
/************************************************************************/
/******/ ({

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var showForm = function showForm() {
  var form = document.querySelector(".webinar-registration");
  var expiration = form.getAttribute("data-expiration");

  if (expiration === "" || Date.now() > new Date(expiration)) form.classList.add("hide");
};

var getWebinarId = function getWebinarId() {
  var node = document.querySelector('input[name="webinar-id"]');
  var val = node.getAttribute("data-value");
  var splitVal = val.split("/");

  return splitVal[splitVal.length - 1];
};

var submitWebinarForm = function submitWebinarForm() {
  var joinForm = MktoForms2.getForm(1032);
  var form = document.forms["register-webinar"];
  var wrapper = document.querySelector(".webinar-registration");

  joinForm.onSuccess(function (values, followUpUrl) {
    wrapper.classList.add("confirmation");
    return false;
  });

  joinForm.setValues({
    FirstName: form["first-name"].value,
    LastName: form["last-name"].value,
    Email: form.email.value,
    Organization: form.organization.value,
    Title: form["job-title"].value,
    webinarProgramName: getWebinarId()
  });

  joinForm.submit();
};

var addMarketoHandlers = function addMarketoHandlers() {
  var form = document.forms["register-webinar"];

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var email = form.email.value;
    var emailValid = /@.*?\./.test(email);

    if (emailValid) {
      submitWebinarForm();
    } else {
      form.classList.add("email-error");
    }
  });
};

var init = function init() {
  showForm();
  addMarketoHandlers();
  MktoForms2.loadForm("//app-ab10.marketo.com", "572-JSV-775", 1032);
};

document.addEventListener("DOMContentLoaded", init);

/***/ }),

/***/ 146:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(116);

__webpack_require__(146);

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// /assets/js/webinarDetails.f88974b6770e51f9a7c6.js